import React, {Component} from 'react'
import {_getIAAAvailableAccounts} from "../../../../../../services/apis/WorkerServices"

class IAAAvailableAccounts extends Component {
    state = {
        total: 0
    }

    _refresh = null

    componentDidMount() {
        this._fetchAvailable()
        this._refresh = setInterval(() => {
            this._fetchAvailable()
        }, 5000)
    }

    componentWillUnmount() {
        this._refresh && clearInterval(this._refresh)
    }

    _fetchAvailable = async () => {
        const {data, success} = await _getIAAAvailableAccounts()

        if (success) {
            this.setState({
                total: data
            })
        }
    }

    render() {
        return (
            <div className="IAAAvailableAccounts">
                <strong>Available:</strong>
                <span className="Number"> {this.state.total} workers</span>
            </div>
        )
    }
}

export default IAAAvailableAccounts



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/workers/components/iaa/IAAAvailableAccounts.js